/* eslint-disable guard-for-in */
/* eslint-disable no-restricted-syntax */
import Vue from 'vue';
import { Message, MessageBox } from 'element-ui';
import _ from 'lodash';
import {
    GET_WORKER_ORDER_LIST_REQUEST,
    GET_WORKER_ORDER_LIST_SUCCESS,
    GET_WORKER_ORDER_LIST_FAILURE,
    UPDATE_WORKER_ORDER_LIST,
    UPDATE_WORKER_ORDER_LIST_PARAMS,
    RESET_WORKER_ORDER_LIST,
    RESOLVE_WORKER_ORDER_LIST_PARAMS,
    UPDATE_WORKER_WAIT_DATA
} from '../mutationTypes';

const state = {
    loading: false,
    state: 2, // 状态（1：全部，2：未支付，3：已完成，4：已取消）
    page: 1,
    pagesize: 20,
    name: '',
    mobile: '',
    payType: 3, // 支付类型,1当面付(默认),2现金,3微信,4支付宝,5刷卡
    companyName: '', // 企业名称
    carNo: '',
    orderNo: '',
    operate_count:'',
    startEndDate: [], // 组件返回形式为数组, 请求时分开提交
    listData: [],
    waitData: {},
    pageCount: 1,
    reqParams: {}
};

const mutations = {
    [GET_WORKER_ORDER_LIST_REQUEST](state) {
        state.loading = true;
    },
    [GET_WORKER_ORDER_LIST_SUCCESS](state, res) {
        state.loading = false;
        state.pageCount = res.page_count;
        state.listData = res.listData;
        state.waitData = res.waitData;
    },
    [UPDATE_WORKER_WAIT_DATA](state, res) {
        state.waitData = res;
    },
    [UPDATE_WORKER_ORDER_LIST](state, res) {
        state.listData = res;
    },
    [GET_WORKER_ORDER_LIST_FAILURE](state) {
        state.loading = false;

        state.pageCount = 1;
        state.listData = [];
    },
    // 更新请求参数
    [UPDATE_WORKER_ORDER_LIST_PARAMS](state, params) {
        const {
            name, mobile, page, carNo,
            orderNo, startEndDate,
            orderState, operateCount,
            payType, companyName
        } = params;

        if (name || name === '') state.name = name;
        if (mobile || mobile === '') state.mobile = mobile;
        if (carNo || carNo === '') state.carNo = carNo;
        if (orderNo || orderNo === '') state.orderNo = orderNo;
        if (operateCount || operateCount === '') state.operate_count = operateCount;
        if (orderState) state.state = orderState;
        if (payType) state.payType = payType;
        if (payType) state.reqParams.payType = payType;
        if (companyName || companyName === '') state.companyName = companyName;
        if (startEndDate) {
            state.startEndDate = startEndDate;
        }

        if (page) {
            state.page = page;
            state.reqParams.page = page; // 分页要进行请求
        }
    },
    [RESET_WORKER_ORDER_LIST](state) {
        _.extend(state, _.cloneDeep({
            loading: false,
            state: 2,
            page: 1,
            pagesize: 20,
            name: '',
            mobile: '',
            payType: 3,
            companyName: '',
            carNo: '',
            orderNo: '',
            operate_count: '',
            startEndDate: [],
            listData: [],
            pageCount: 1,
            reqParams: {}
        }));
    },
    [RESOLVE_WORKER_ORDER_LIST_PARAMS](state, reqParams) {
        state.reqParams = reqParams;
    },
};

export const actions = {
    async getWorkerOrderList({ commit }) {
        commit(GET_WORKER_ORDER_LIST_REQUEST);
        const res = await Vue.$ajax.get('worderList', state.reqParams);
        if (!res.errorType) {
            commit(GET_WORKER_ORDER_LIST_SUCCESS, res);
        } else {
            commit(GET_WORKER_ORDER_LIST_FAILURE);
        }
    },
    async exportWorkerOrderList() {
        const res = await Vue.$ajax.get('exportOrders', state.reqParams);
        if (!res.errorType) {
            Message({
                message: '导出成功',
                tyep: 'success'
            });
        } else {
            MessageBox.alert(res.errmsg || '未知错误', '提交失败！', {
                confirmButtonText: '知道了'
            });
        }
    },
    resolveWorkerOrderListParams({ commit }) {
        let params = _.pick(state, ['name', 'mobile', 'state',
            'page', 'pagesize', 'carNo', 'orderNo', 'operate_count', 'payType', 'companyName']);

        params = Object.assign({}, params, {
            startDate: state.startEndDate.length ? state.startEndDate[0] : null,
            endDate: state.startEndDate.length ? state.startEndDate[1] : null
        });
        commit(RESOLVE_WORKER_ORDER_LIST_PARAMS, params);
    },
    resetWorkerOrderList({ commit }) {
        commit(RESET_WORKER_ORDER_LIST);
    }
};

export default {
    state,
    mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/workerOrderList.js